import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface InitiatePaymentResponse {
  merchantTransactionId: string;
  redirectUrl: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(private http: HttpClient) {}

  initiatePhonePePayment(planId: number): Observable<InitiatePaymentResponse> {
    return this.http.post<InitiatePaymentResponse>(`${environment.apiUrl}/payments/phonepe/initiate`, { planId });
  }

  checkStatus(merchantTransactionId: string): Observable<{ status: string; planId: number | null }> {
    return this.http.get<{ status: string; planId: number | null }>(
      `${environment.apiUrl}/payments/phonepe/status/${merchantTransactionId}`
    );
  }

  /** Redirects the full browser window to PhonePe's hosted checkout page. */
  redirectToCheckout(redirectUrl: string): void {
    window.location.href = redirectUrl;
  }
}
